/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationStoreInAppSteamSteamInAppBillingData
 */
export interface FxIdApplicationStoreInAppSteamSteamInAppBillingData {
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationStoreInAppSteamSteamInAppBillingData
     */
    OrderId: number;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreInAppSteamSteamInAppBillingData
     */
    DeveloperPayload: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreInAppSteamSteamInAppBillingData
     */
    Sku: string;
}

/**
 * Check if a given object implements the FxIdApplicationStoreInAppSteamSteamInAppBillingData interface.
 */
export function instanceOfFxIdApplicationStoreInAppSteamSteamInAppBillingData(value: object): value is FxIdApplicationStoreInAppSteamSteamInAppBillingData {
    if (!('OrderId' in value) || value['OrderId'] === undefined) return false;
    if (!('DeveloperPayload' in value) || value['DeveloperPayload'] === undefined) return false;
    if (!('Sku' in value) || value['Sku'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreInAppSteamSteamInAppBillingDataFromJSON(json: any): FxIdApplicationStoreInAppSteamSteamInAppBillingData {
    return FxIdApplicationStoreInAppSteamSteamInAppBillingDataFromJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppSteamSteamInAppBillingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreInAppSteamSteamInAppBillingData {
    if (json == null) {
        return json;
    }
    return {
        
        'OrderId': json['OrderId'],
        'DeveloperPayload': json['DeveloperPayload'],
        'Sku': json['Sku'],
    };
}

export function FxIdApplicationStoreInAppSteamSteamInAppBillingDataToJSON(json: any): FxIdApplicationStoreInAppSteamSteamInAppBillingData {
    return FxIdApplicationStoreInAppSteamSteamInAppBillingDataToJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppSteamSteamInAppBillingDataToJSONTyped(value?: FxIdApplicationStoreInAppSteamSteamInAppBillingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'OrderId': value['OrderId'],
        'DeveloperPayload': value['DeveloperPayload'],
        'Sku': value['Sku'],
    };
}

